<h2 mat-dialog-title class="bg-blue text-white">PEO Client-Customer Document Split Status</h2>
<mat-dialog-content>
  <p>
    Below are the client's print statistics and the status of their split documents.  If their documents are
    <strong>not</strong> currently split and they have printed recently, then the client's print settings will
    need to be reconfigured to the PrismHR settings so their employees can view their individual documents.
  </p>
  <mat-divider></mat-divider>
  <mat-list>

    <!-- Documents Setup for Viewer -->
    <mat-list-item>
      <mat-spinner *ngIf="loading" diameter="20" color="warn" matListItemIcon></mat-spinner>
      <mat-icon *ngIf="!loading && !client?.documentsSplitForViewer" color="icon-red" matListItemIcon>report</mat-icon>
      <mat-icon *ngIf="!loading && client?.documentsSplitForViewer" color="icon-green" matListItemIcon>check</mat-icon>
      <div matListItemTitle>Documents Setup for 1095 Viewer</div>
      <div matListItemLine>
        If this is not configured then our 1095 document viewer won't work.
      </div>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Preview Documents -->
    <mat-list-item>
      <mat-spinner *ngIf="loading" diameter="20" color="warn" matListItemIcon></mat-spinner>
      <mat-icon *ngIf="!loading && (!client?.previewDocuments && client?.previewDocuments !== 0)" color="icon-red"
                matListItemIcon>report</mat-icon>
      <span *ngIf="!loading && (client?.previewDocuments || client?.previewDocuments === 0)" matListItemIcon>
        {{ client?.previewDocuments }}
      </span>
      <div matListItemTitle>Preview Documents</div>
      <div matListItemLine>The total number of previews the client-customer currently has.</div>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Print Documents -->
    <mat-list-item>
      <mat-spinner *ngIf="loading" diameter="20" color="warn" matListItemIcon></mat-spinner>
      <mat-icon *ngIf="!loading && (!client?.printDocuments && client?.printDocuments !== 0)" color="icon-red"
                matListItemIcon>report</mat-icon>
      <span *ngIf="!loading && (client?.printDocuments || client?.printDocuments === 0)" matListItemIcon>
        {{ client?.printDocuments }}
      </span>
      <div matListItemTitle>Print Documents</div>
      <div matListItemLine>The total number of prints the client-customer currently has.</div>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Re-Printed Documents -->
    <mat-list-item>
      <mat-spinner *ngIf="loading" diameter="20" color="warn" matListItemIcon></mat-spinner>
      <mat-icon *ngIf="!loading && (!client?.reprintDocuments && client?.reprintDocuments !== 0)" color="icon-red"
                matListItemIcon>report</mat-icon>
      <span *ngIf="!loading && (client?.reprintDocuments || client?.reprintDocuments === 0)" matListItemIcon>
        {{ client?.reprintDocuments }}
      </span>
      <div matListItemTitle>Re-Print Documents</div>
      <div matListItemLine>The total number of re-prints the client-customer currently has.</div>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Corrected Documents -->
    <mat-list-item>
      <mat-spinner *ngIf="loading" diameter="20" color="warn" matListItemIcon></mat-spinner>
      <mat-icon *ngIf="!loading && (!client?.correctedDocuments && client?.correctedDocuments !== 0)" color="icon-red"
                matListItemIcon>report</mat-icon>
      <span *ngIf="!loading && (client?.correctedDocuments || client?.correctedDocuments === 0)" matListItemIcon>
        {{ client?.correctedDocuments }}
      </span>
      <div matListItemTitle>Corrected Documents</div>
      <div matListItemLine>The total number of correctional prints the client-customer currently has.</div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    <mat-icon>close</mat-icon>
    I'm done
  </button>
</mat-dialog-actions>
